import { AbstractModel } from './AbstractModel'
import { VotingAnswer } from './VotingAnswer'
import { Http } from '@/lib/utils/Http'

export class Voting extends AbstractModel {
  public id: number|null = null;
  public name: string|null = null;
  public answers: VotingAnswer[] = [];
  public totalVotes: number|null = null;
  public selectedVote: number|null = null;
  public createdAt: string|null = null;
  public updatedAt: string|null = null;

  public async vote (chosenAnswer: number, ip: string) {
    const localStorageVote = localStorage.getItem(`vote-${this.id}`)
    const localStorageIp = localStorage.getItem(`vote-${this.id}-ip`)
    if (localStorageIp) {
      ip = localStorageIp
    } else {
      localStorage.setItem(`vote-${this.id}-ip`, ip)
    }
    if (localStorageVote === null || parseInt(localStorageVote) !== chosenAnswer) {
      const res = await Http.request(`/api/voting/${chosenAnswer}/${ip}/vote`)
    }
    localStorage.setItem(`vote-${this.id}`, chosenAnswer.toString())
  }
}
